<table class="selectableTable">
  <tr>
    <th class="sortable">Year</th>
    <th class="sortable">Month</th>
    <th class="sortable">Transactions</th>
    <th class="sortable">Revenue</th>
    <!--<th class="sortable">Statements</th>-->
  </tr>
  @for (
    item of this.dataSource.data;
    track item.year + '-' + item.month;
    let even = $even;
    let odd = $odd
  ) {
    <tr
      [ngClass]="{ even: even, odd: odd }"
      class="rowSummary highlightable"
      (click)="_selectRow_click(item.year, item.month)"
    >
      <td>{{ item.year }}</td>
      <td>{{ getMonthName(item.month) }}</td>
      <td>{{ item.count }}</td>
      <td>{{ getFormattedCurrency(item.revenue) }}</td>
    </tr>
  }
</table>
